import { getFromLocalStorage, setInLocalStorage } from '../../../../../helpers/window';

export const RECENT_SEARCHES_KEY = 'recentSearches';
export const RECENT_SEARCHES_LIMIT = 3;

export type RecentSearch = {
  query: string;
};

export const getLocalRecentSearches = (): RecentSearch[] => {
  const recentSearches = getFromLocalStorage(RECENT_SEARCHES_KEY);
  if (!recentSearches) return [];

  return JSON.parse(recentSearches) as RecentSearch[];
};

export const filterSimilar = (query: string, recentSearches: RecentSearch[]): RecentSearch[] =>
  recentSearches.filter((recentSearch) => !query.includes(recentSearch.query));

export const prependRecentSearch = (query: string, recentSearches: RecentSearch[]): RecentSearch[] =>
  [{ query }, ...recentSearches];

export const limitRecentSearches = (limit: number, recentSearches: RecentSearch[]): RecentSearch[] =>
  recentSearches.slice(0, limit);

export const removeFromRecentSearchArray = (query: string, recentSearches: RecentSearch[]): RecentSearch[] =>
  recentSearches.filter((search) => search.query !== query);

const storeRecentSearches = (array: RecentSearch[]): void => {
  // TODO(consent): use `useConsent()` hook to check if user has given consent (marketing) to store marketing data
  setInLocalStorage(RECENT_SEARCHES_KEY, JSON.stringify(array));
};

export const fetchRecentSearches = (): RecentSearch[] => {
  const recentSearches = getLocalRecentSearches();
  return limitRecentSearches(RECENT_SEARCHES_LIMIT, recentSearches);
};

export const isFilledArray = (array: unknown[]): boolean => array.length > 0;

export const addQueryToRecentSearches = (query: string): void => {
  let recentSearches = getLocalRecentSearches();
  recentSearches = filterSimilar(query, recentSearches);
  recentSearches = prependRecentSearch(query, recentSearches);
  recentSearches = limitRecentSearches(RECENT_SEARCHES_LIMIT, recentSearches);
  storeRecentSearches(recentSearches);
};

export const removeQueryFromRecentSearches = (query: string): void => {
  let recentSearches = getLocalRecentSearches();
  recentSearches = removeFromRecentSearchArray(query, recentSearches);
  storeRecentSearches(recentSearches);
};

export const hasRecentSearches = (): boolean => {
  const recentSearches = getLocalRecentSearches();
  return isFilledArray(recentSearches);
};
